import React from "react";
import ReactLoading from "react-loading";
import { makeStyles, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() =>
    createStyles({
        loading: {
            width: `20%`,
            margin: `0 auto`,
            marginTop: 10,
            position: `absolute`,
            top: `50%`,
            left: `50%`,
        },
    })
);

interface Props {
    // ローディング
    isLoading: boolean;
}

export const Loading: React.FC<Props> = (props) => {
    const classes = useStyles();
    const { isLoading } = props;

    if (!isLoading) {
        return <></>;
    }
    return (
        <div
            style={{
                zIndex: 9999,
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#A9A9A9",
                opacity: 0.5,
            }}
        >
            <ReactLoading type="spin" className={classes.loading} />
        </div>
    );
};
